import React, { useState } from 'react';

export const ThemeContext = React.createContext();
export const ThemeProvider = ({ children }) => {
  const [data, setData] = useState({});

  return <ThemeContext.Provider value={{ data }}>{children}</ThemeContext.Provider>;
};
